var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Angulartics2 } from 'angulartics2';
import { AuthService } from 'app/user/auth.service';
import { DefaultService } from 'app/services/default.service';
import { EnvironmentService } from 'app/services/environment.sevice';
import { GeolocationService } from 'app/services/geolocation.service';
import { getPolicyData } from 'app/services/policy.service';
import { settings } from 'app/core/settings';
import { camelCase } from 'app/core/case-transform';
import { validate } from 'app/user/form.functions';
var ProductInterest = /** @class */ (function () {
    function ProductInterest() {
        this.invoiceProcessing = true;
        this.invoiceServiceApi = true;
        this.hostedCloud = true;
    }
    ProductInterest.prototype.isSet = function () {
        return this.invoiceProcessing || this.invoiceServiceApi || this.hostedCloud;
    };
    ProductInterest.prototype.toLead = function () {
        var products = [
            this.invoiceProcessing && 'FlexiCapture for Invoices Cloud',
            this.invoiceServiceApi && 'FlexiCapture for Invoices API Cloud',
            this.hostedCloud && 'FlexiCapture Cloud'
        ];
        return products.filter(function (product) { return !!product; }).join(';');
    };
    return ProductInterest;
}());
var RegisterComponent = /** @class */ (function () {
    function RegisterComponent(_router, _authService, _angulartics2, _geolocationService, defaultService, environmentService) {
        var _this = this;
        this._router = _router;
        this._authService = _authService;
        this._angulartics2 = _angulartics2;
        this._geolocationService = _geolocationService;
        this.policy = {
            privacyPolicyUrl: 'https://www.abbyy.com/privacy/?version=default',
            cookiePolicyUrl: 'https://www.abbyy.com/cookie-policy',
            type: 'ALL'
        };
        this.registration = {
            firstName: null,
            lastName: null,
            email: null,
            company: null,
            phone: null,
            country: null,
            currency: defaultService.currency,
            language: defaultService.language,
            timeZoneOffset: environmentService.timeZoneOffset,
            confirmationUrl: environmentService.mainServer + '/password/set/%7Btoken%7D',
            passwordChangeUrl: environmentService.mainServer + '/password/change/%7Btoken%7D',
            projectDetails: null,
            subscribeToEmails: false,
            accepted: true,
            hasTenant: false,
            services: new ProductInterest(),
            tosCheckbox: false,
            privacyAndCookie: false
        };
        this.countries = this._geolocationService
            .getCountriesNames()
            .map(function (country) { return ({
            label: country.name,
            value: country.name,
            code: country.code,
            lowerCaseValue: country.name.toLowerCase()
        }); });
        this.filteredCountries = this.countries;
        this.subscription = this._geolocationService
            .locate()
            .subscribe(function (geolocation) {
            _this._setLocation(geolocation);
        });
    }
    Object.defineProperty(RegisterComponent.prototype, "settings", {
        get: function () {
            return settings;
        },
        enumerable: true,
        configurable: true
    });
    RegisterComponent.prototype.isLengthMaxProjectDetails = function () {
        return (this.registration.projectDetails &&
            this.registration.projectDetails.length === 1024);
    };
    RegisterComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    RegisterComponent.prototype.countriesSelected = function (value) {
        this.policy = getPolicyData(value.code);
    };
    RegisterComponent.prototype.onFilterInputChanged = function (term) {
        this.filteredCountries = this.countries.filter(function (country) {
            return country.lowerCaseValue.startsWith(term);
        });
    };
    RegisterComponent.prototype.onSelectClosed = function () {
        this.filteredCountries = __spread(this.countries);
    };
    RegisterComponent.prototype.validate = function (form) {
        validate(form);
    };
    RegisterComponent.prototype.onHideError = function () {
        this.error = null;
    };
    RegisterComponent.prototype.onSubmit = function (form) {
        var _this = this;
        if (form.invalid) {
            return;
        }
        this.error = null;
        this.errorDescription = null;
        this.processing = true;
        this._authService.register(this.registration).subscribe(function () { return _this._onSuccess(); }, function (response) { return _this._onError(response); });
    };
    RegisterComponent.prototype._onSuccess = function () {
        var isUSGroupCountry = ['CA_JP', 'US'].includes(this.policy.type);
        var lead = {
            firstName: this.registration.firstName,
            lastName: this.registration.lastName,
            email: this.registration.email,
            company: this.registration.company,
            phone: this.registration.phone,
            country: this.registration.country,
            language: this.registration.language,
            projectDetails: this.registration.projectDetails,
            hasTenant: this.registration.hasTenant,
            unsubscribed: !this.registration.subscribeToEmails,
            projectDescriptionTemp: this.registration.projectDetails,
            productInterestTemp: this.registration.services.toLead(),
            GDPRConsentForProcessing: isUSGroupCountry
                ? null
                : this.registration.privacyAndCookie,
            GDPRConsentNotes: isUSGroupCountry
                ? null
                : "User provided consent by filling out FlexiCapture Cloud Registration form at " + window.location + " " + new Date().toUTCString(),
            optIn: this.registration.subscribeToEmails,
            isTest: this._isTestEmail(this.registration.email)
        };
        this._angulartics2.setUserProperties.next(lead);
        this._router.navigateByUrl('/');
    };
    RegisterComponent.prototype._isTestEmail = function (email) {
        var testDomains = {
            '@abbyy.com': true,
            '@mailforspam.com': true,
            '@mailinator.com': true,
            '@mfsa.ru': true,
            '@sharklasers.com': true,
            '@mfsa.info': true
        };
        var domain = email.substring(email.indexOf('@'));
        return domain in testDomains;
    };
    RegisterComponent.prototype._sendRegistrationSuccess = function (email) {
        this._angulartics2.setUsername.next(email);
        this._angulartics2.eventTrack.next({
            action: 'RegistrationSuccess',
            properties: {
                event: 'RegistrationSuccess'
            }
        });
    };
    RegisterComponent.prototype._onError = function (response) {
        if (response.status === 400) {
            var responseJson = response.json();
            this.error = camelCase(responseJson.error);
            this.errorDescription = this._getErrorDescription(responseJson);
        }
        this.processing = false;
    };
    RegisterComponent.prototype._getErrorDescription = function (responseJson) {
        var modelState = responseJson.modelState;
        if (!modelState) {
            return responseJson.errorDescription;
        }
        return Object.keys(modelState)
            .map(function (fieldName) { return modelState[fieldName].join('\n'); })
            .join('\n');
    };
    RegisterComponent.prototype._setLocation = function (_a) {
        var country = _a.country;
        if (this.registration.country) {
            return;
        }
        this.registration.country = country.name;
        this.policy = getPolicyData(country.code);
    };
    return RegisterComponent;
}());
export { RegisterComponent };
